<script>
import baseMixin from '@mixins/baseMixin.js'
import { mapActions, mapGetters } from 'vuex'

export default {
  Name: 'MessageInput',
  mixins: [baseMixin],
  props: {
    recipientId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      message: '',
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'message/isLoadingMessageCRUD',
      getMessagesByCandidateId: 'message/getMessagesByCandidateId',
    }),
  },
  methods: {
    ...mapActions({
      sendMessageAsync: 'message/sendMessage',
    }),
    async sendMessage() {
      if (!this.message) return
      const messages = this.getMessagesByCandidateId(this.recipientId)
      const result = await this.sendMessageAsync({
        recipientId: this.recipientId,
        message: this.message,
        type: messages.contactType,
      })

      // Clear message on successful send
      if (result.isSuccess) {
        this.message = ''
        this.$emit('sent')
      }
    },
  },
}
</script>

<template>
  <v-card-text class="d-flex align-center">
    <v-textarea
      v-model="message"
      filled
      :dense="isMobileViewPort"
      auto-grow
      :disabled="isLoading"
      hide-details
      placeholder="Type a new message"
      rows="1"
    ></v-textarea>
    <v-btn
      :disabled="!message"
      color="blue"
      title="send"
      large
      :loading="isLoading"
      icon
      class="ml-4"
      @click="sendMessage"
    >
      <v-icon>mdi-send</v-icon>
    </v-btn>
  </v-card-text>
</template>
